import { describe, expect,it } from 'vitest';

import { CARD_CATEGORIES } from '../../../../../../../shared/cardConfig/constants';
import { ATTACHMENT_FIELDS,BILL_TO_ADDRESS_FIELDS } from '../../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../../utils/constants';
import type { Card,Field,Page } from '..'; // Assuming you exported types from your page template file
import pages from '..';

describe('BillTo Page Template', () => {
  it('exports one page', () => {
    expect(Array.isArray(pages)).toBe(true);
    expect(pages).toHaveLength(1);
  });

  const billToPage: Page = pages[0];

  it('has correct route', () => {
    expect(billToPage.route).toBe(PAGE_ROUTES.company);
  });

  it('contains expected cards', () => {
    expect(Array.isArray(billToPage.cards)).toBe(true);
    expect(billToPage.cards).toHaveLength(3);
  });

  // ------------------ BillTo Address Card ------------------
  describe('BillTo Address Card', () => {
    const billToCard = billToPage.cards.find(
      (c: Card) => c.key === CARD_CATEGORIES.billTo
    ) as Card;

    it('has hideSameAs enabled', () => {
      expect(billToCard.hideSameAs).toBe(true);
    });

    it('has correct fields', () => {
      expect(billToCard.fields?.map((f: Field) => f.key)).toEqual([
        BILL_TO_ADDRESS_FIELDS.address,
        BILL_TO_ADDRESS_FIELDS.taxNumber1,
        BILL_TO_ADDRESS_FIELDS.taxNumber2,
        BILL_TO_ADDRESS_FIELDS.taxNumber3
      ]);
    });
  });

  // ------------------ Additional Attachment Card ------------------
  describe('Additional Attachment Card', () => {
    const attachmentCard = billToPage.cards.find(
      (c: Card) => c.key === CARD_CATEGORIES.additionalAttachmentCard
    ) as Card;

    it('has correct field', () => {
      expect(attachmentCard.fields?.[0].key).toBe(ATTACHMENT_FIELDS.additionalAttachment);
    });
  });

  // ------------------ Privacy Policy Card ------------------
  describe('Privacy Policy Card', () => {
    const privacyCard = billToPage.cards.find(
      (c: Card) => c.key === CARD_CATEGORIES.privacyPolicy
    ) as Card;

    it('has no fields', () => {
      expect(privacyCard.fields).toBeUndefined();
    });
  });
});